// extracted by mini-css-extract-plugin
module.exports = {"container":"file-outliner_container__lsP_y","content":"file-outliner_content__PMNnD","title":"file-outliner_title__rcSa2","tree":"file-outliner_tree__8LC_y"};